<template>
	<div class="gb-page">
		<HeadNav selectedLanguage="en" page="download" />

		<!-- 仅统一视觉风格，文案与原先保持一致 -->
		<section class="gb-hero dl-hero">
			<div class="gb-hero-bg" aria-hidden="true">
				<span class="blob blob-left"></span>
				<span class="blob blob-right"></span>
				<span class="dots dots-tl"></span>
				<span class="dots dots-br"></span>
			</div>

			<div class="gb-hero-inner dl-hero-inner">
				<div class="gb-hero-copy">
					<h1>
						<span class="title-dark">Download GB WhatsApp APK v18.80 for Android</span>
					</h1>

					<img
						class="content-img dl-top-logo"
						:src="downloadImg"
						alt="Download GB WhatsApp APK v18.80 for Android"
						loading="lazy"
					/>

					<p class="gb-hero-lead">
						Download the latest GB WhatsApp APK for Android. Get the updated version with new privacy
						options, customization features, and improved performance.
					</p>
					<p class="gb-hero-lead">
						Before installing, make sure to back up your chats if you are updating from an older version. The
						APK file works on Android devices running Android 5.0 and above.
					</p>

					<div class="gb-hero-actions">
						<a class="gb-btn gb-btn-primary" href="javascript:;" @click.prevent="download">
							<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2">
								<path d="M12 3v12" />
								<path d="M7 10l5 5 5-5" />
								<path d="M5 19h14" />
							</svg>
							Download GB WhatsApp APK
						</a>
					</div>
				</div>
			</div>
		</section>

		<article class="gb-article">
			<hh2>GB WhatsApp v18.80</hh2>
			<p><strong>Latest Stable Version</strong></p>
			<div class="gb-table-wrap">
				<table class="gb-table">
					<thead>
						<tr>
							<th>Information</th>
							<th>Details</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(row, idx) in appInfo" :key="idx">
							<td>{{ row.info }}</td>
							<td>{{ row.details }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<hh2>Before Installing GB WhatsApp</hh2>
			<p>Before installing the APK file, follow these simple steps:</p>

			<div class="alt-cards dl-prep-cards">
				<article class="alt-card">
					<h3>Backup Your Chats</h3>
					<p>
						If you are currently using WhatsApp or an older GB WhatsApp version, create a backup first. This
						helps protect your conversations, photos, and important files.
					</p>
				</article>
				<article class="alt-card">
					<h3>Check Storage Space</h3>
					<p>Make sure your phone has enough free storage before starting the installation process.</p>
				</article>
				<article class="alt-card">
					<h3>Enable APK Installation</h3>
					<p>
						Android may block APK installation by default. If this happens, allow installation from unknown
						sources in your device settings.
					</p>
				</article>
			</div>

			<hh2>How to Install GB WhatsApp APK</hh2>
			<p>Installing GB WhatsApp is simple:</p>
			<ol class="dl-steps">
				<li>Download the APK file from this page.</li>
				<li>Open the downloaded file from your phone's Downloads folder.</li>
				<li>Tap <strong>Install</strong> and wait for the process to complete.</li>
				<li>Open GB WhatsApp and verify your phone number.</li>
				<li>Restore your backup if available.</li>
			</ol>
			<p>
				After installation, you can start using GB WhatsApp with additional privacy settings, customization
				options, and extra messaging tools.
			</p>

			<hh2>What's Included in GB WhatsApp v18.80?</hh2>
			<p>The latest version includes improvements designed to provide a smoother messaging experience.</p>
			<p>Key features include:</p>
			<ul>
				<li>Advanced privacy controls</li>
				<li>Custom themes and interface options</li>
				<li>Hide online status</li>
				<li>Auto reply and message scheduling</li>
				<li>Status downloader</li>
				<li>Larger media sharing options</li>
				<li>Chat customization tools</li>
			</ul>

			<hh2>GB WhatsApp APK Requirements</hh2>
			<div class="info-list">
				<p>✓ Android 5.0 or higher</p>
				<p>✓ Enough storage space available</p>
				<p>✓ Stable internet connection</p>
				<p>✓ Backup completed before updating</p>
			</div>
		</article>
	</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import '@/css/gbappss.scss'
import HeadNav from '@/components/HeadNav.vue'
import { APK_DOWNLOAD_URL } from '@/downloadConfig'

export default {
	name: 'Download',
	components: { HeadNav },
	data() {
		return {
			downloadUrl: APK_DOWNLOAD_URL,
			downloadImg: require('@/assets/home/logo-doc.webp'),
			appInfo: [
				{ info: 'App Name', details: 'GB WhatsApp' },
				{ info: 'Version', details: 'v18.80' },
				{ info: 'File Size', details: '95 MB' },
				{ info: 'Android Support', details: 'Android 5.0+' },
				{ info: 'Updated', details: 'July 2026' },
				{ info: 'Category', details: 'Communication' },
				{ info: 'File Type', details: 'APK' },
			],
		}
	},
	methods: {
		download() {
			window.location.href = this.downloadUrl
		},
	},
}
</script>
